export default __webpack_public_path__ + "static/media/leavesImg.0bf55750.png";